import { type Plugin } from "@nuxt/types";

import BranchService from "@/utils/services/BranchService";

declare module "vue/types/vue" {
  interface Vue {
    $branch: BranchService;
  }
}

declare module "@nuxt/types" {
  interface Context {
    $branch?: BranchService;
  }
}

declare module "vuex/types/index" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Store<S> {
    $branch?: BranchService;
  }
}

const plugin: Plugin = (context, inject) => {
  const branch = new BranchService(context);

  inject("branch", branch);
  context.$branch = branch;
};

export default plugin;
